import { FETCH_SHIFT } from './actionType'

const initialState = {
  shift: {},
  // profileData: {},
  // userLocation: DEFAULT_DATA
}
const shiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIFT:
      return {
        ...state,
        shift: action.payload,
      }
    // case USER_PROFILE:
    //     return {
    //         ...state,
    //         profileData: action.payload
    //     };
    // case USER_LOCATION:
    //     return {
    //         ...state,
    //         userLocation: action.payload
    //     };
    default:
      return state
  }
}

export default shiftReducer
